import { Button } from '../../ui/Button/Button';
import S from './ToolbarStyles';

const PERIODS = [
  { label: 'Day', value: 'daily' },
  { label: 'Week', value: 'weekly' },
  { label: 'Month', value: 'monthly' },
  { label: 'All', value: 'all' },
];

type Props = {
  filters?: Record<string, string[]>;
  setFilters?: (args: any) => void;
};

function ScorePeriodSelector({ filters, setFilters }: Props): JSX.Element {
  const current = filters?.period?.[0] ?? 'all';

  const handleClick = (value: string): void => {
    if (setFilters) {
      setFilters({ ...filters, period: [value] });
    }
  };

  return (
    <S.InnerWrapper>
      {PERIODS.map(({ label, value }) => (
        <Button
          key={value}
          height="26px"
          width="72px"
          borderRadius="100px"
          padding="4px 16px"
          gap="4px"
          active={current === value}
          onClick={() => handleClick(value)}
        >
          <p>{label}</p>
        </Button>
      ))}
    </S.InnerWrapper>
  );
}

export default ScorePeriodSelector;
